
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class CustomCredentials {
	static screenCoders: CustomCredentialsType = 'Screen.Coders';
	static screenCommercialManagement: CustomCredentialsType = 'Screen.CommercialManagement';
	static salesWK: CustomCredentialsType = 'Screen.SalesWK';
	static salesGroupOnline: CustomCredentialsType = 'Screen.SalesGroupOnline';

	static values = ['Screen.Coders', 'Screen.CommercialManagement', 'Screen.SalesWK', 'Screen.SalesGroupOnline'];
}
export type CustomCredentialsType = 'Screen.Coders' | 'Screen.CommercialManagement' | 'Screen.SalesWK' | 'Screen.SalesGroupOnline';

